"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  applyLicense: true
};
Object.defineProperty(exports, "applyLicense", {
  enumerable: true,
  get: function () {
    return _applyLicense.default;
  }
});
var _applyLicense = _interopRequireDefault(require("./applyLicense"));
var _xLicense = require("@ori-ui/mui-x-bundle/x-license");
Object.keys(_xLicense).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _xLicense[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _xLicense[key];
    }
  });
});
(0, _applyLicense.default)();
//# sourceMappingURL=index.js.map